"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.builtinResolvers = exports.builtinOperators = exports.flatten = void 0;
function flatten(value) {
    let arrValue = [];
    if (value === null || value === undefined) {
        return [true];
    }
    if (Array.isArray(value)) {
        arrValue = value;
    }
    else if (typeof value === "object") {
        arrValue = Object.keys(value)
            .map(fnName => ({
            [fnName]: value[fnName]
        }));
    }
    else {
        return [value];
    }
    return arrValue.filter(item => {
        if (typeof item === "boolean") {
            return true;
        }
        return Object.keys(item).length !== 0;
    });
}
exports.flatten = flatten;
exports.builtinOperators = {
    $or: results => results.includes(true),
    $not: results => results.includes(false),
    $and: results => !results.includes(false),
};
exports.builtinResolvers = {
    /**
     * @returns `true` if plugin exists in pluginRegistry
     */
    pluginExists(value, ctx) {
        return Boolean(ctx.platform.pluginRegistry.contributionIndex.getIndex()[value]);
    },
};
